function defaultClasses(properties: Record<string, boolean> = {}): Record<string, boolean> {
  const { loading, valid, enabled, selected, readOnly } = properties;

  return {
    'is-selected': selected === true,
    'is-invalid': valid === false,
    'is-disabled': enabled === false,
    'is-loading': loading === true,
    'is-read-only': readOnly === true,
  };
}

export default defaultClasses;
